import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import AdBanner from '../../components/AdBanner';
import './FortunePage.css';

function FortunePage() {
  return (
    <div className="fortune-main-page">
      <SEO
        title="AI 운세 - 인공지능 오늘의 운세 & GPT 로또 운세"
        description="AI 운세와 인공지능 오늘의 운세를 GPT가 매일 생성합니다. AI 별자리 운세, AI 띠 운세, AI 타로 카드로 총운, 애정운, 금전운, 건강운과 행운의 숫자를 확인하세요."
        keywords="AI 운세, 인공지능 운세, GPT 운세, 챗GPT 운세, AI 오늘의 운세, AI 별자리 운세, AI 타로, 로또 운세, 로또운세, 오늘의 운세 숫자, 오늘의운세, 별자리운세, 띠운세, 무료운세, AI 행운의 숫자"
        url="https://lottounse.kr/fortune"
      />
      <div className="fortune-hero">
        <h1>🔮 오늘의 운세</h1>
        <p>GPT 인공지능 AI가 매일 새롭게 생성하는 당신만의 운세</p>
      </div>

      <AdBanner />

      <div className="fortune-categories">
        <Link to="/fortune/chinese" className="category-card chinese">
          <div className="category-icon">🐭</div>
          <h2>12띠 운세</h2>
          <p>띠별 오늘의 총운, 애정운, 금전운, 건강운</p>
        </Link>

        <Link to="/fortune/zodiac" className="category-card zodiac">
          <div className="category-icon">♈</div>
          <h2>12별자리 운세</h2>
          <p>별자리별 오늘의 총운, 애정운, 금전운, 건강운</p>
        </Link>

        <Link to="/fortune/tarot" className="category-card tarot">
          <div className="category-icon">🃏</div>
          <h2>타로 카드</h2>
          <p>메이저 아르카나 22장의 오늘의 메시지</p>
        </Link>

        <Link to="/fortune/dream" className="category-card dream">
          <div className="category-icon">🌙</div>
          <h2>꿈해몽</h2>
          <p>AI가 분석하는 꿈의 의미와 행운 번호</p>
        </Link>

        <Link to="/fortune/lucky" className="category-card lucky">
          <div className="category-icon">🍀</div>
          <h2>오늘의 행운</h2>
          <p>행운의 숫자, 색깔, 방향, 아이템</p>
        </Link>
      </div>

      <AdBanner />

      <div className="fortune-info">
        <div className="info-card">
          <h3>💫 매일 새로운 운세</h3>
          <p>
            매일 새벽 3시, GPT AI가 새로운 운세를 생성합니다.
            긍정적이고 희망적인 메시지로 하루를 시작하세요.
          </p>
        </div>

        <div className="info-card">
          <h3>🎯 정확한 분석</h3>
          <p>
            별자리, 띠, 타로 카드별로 세분화된 운세를 확인하고
            오늘의 행운 정보를 활용하세요.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FortunePage;
